import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-600">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
          {item.to ? (
            <Link to={item.to} className="whitespace-nowrap transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="whitespace-nowrap font-medium text-foreground-900">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}